//////////////////////////////////////////////////////////////////////
//
//  10/05/18
//  src/components/NameBlk.js
//
//  This file formats and sets the Name and Icon Row of data.
//

import React   from 'react';
import IconRow from "./IconRow";
import './NameBlk.css';

const NameBlk = ({ miles, name, row, music, food, happy, notes, mpop, fpop, hpop, addr, type }) => (
  <div className="NameBlk">

    <div className={ ( type === "compact" ) ? "NameBlkIconsCompact" : "NameBlkIcons" } >
      <IconRow row={ row }   music={ music } food={ food } happy={ happy } notes={ notes }
               type={ type } mpop ={ mpop  } fpop={ fpop } hpop ={ hpop  } addr ={ addr  } />
    </div>

    <div className={ ( type === "compact" ) ? "NameBlkRowCompact" : "NameBlkRow" } >
      <div className="NameMiles">{ miles }</div>
      <div className="NameDash"> - </div>
      { notes ? ( <div className="NameName"><a href={ addr } target='_blank'>{ name }</a></div> ) : ( <div className="NameName">{ name }</div> ) }
    </div>
  </div>
);

export default NameBlk;



// WEBPACK FOOTER //
// ./src/components/NameBlk.js